import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { RtSrfPage } from "@/features/quality/components/rt-srf/rt-srf-page";

const search = z.object({
  tab: z.enum(["eligible", "made"]).default("eligible"),
  q: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
});

/** SRF for RT Lots (seedtrac QCS p177–178; user, 2026-10-16). */
export const Route = createFileRoute("/_app/quality/rt-srf/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.allocate")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RtSrfPage
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
